import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';
import HVASpinner from 'components/base/HVASpinner';
import ScoreVsDurationChart from 'components/charts/QAScoreVsDurationChart';
import ScoreDistributionChart from 'components/charts/QADistributionChart';
import QAScorecardData4 from './QADashboardScorecardData4';
import {
  fetchHVAScorecardDashScoreVsDuration,
  fetchHVAScorecardDashScoreDistribution
} from 'services/hvaqa.service';

interface QAScorecardData3Props {
  scorecardid: number;
  startdate: Date;
  enddate: Date;
  serviceid: number;
  campaignid: number;
  agentid: number;
}

const QAScorecardData3: React.FC<QAScorecardData3Props> = ({
  scorecardid,
  startdate,
  enddate,
  serviceid,
  campaignid,
  agentid
}) => {
  // eslint-disable-next-line
  const [evolutionData, setEvolutionData] = useState<any>(null);
  // eslint-disable-next-line
  const [distributionData, setDistributionData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);

  // Funciones memoized para obtener los datos
  const fetchData = useCallback(async () => {
    try {
      const response = await fetchHVAScorecardDashScoreVsDuration({
        scorecardid,
        serviceid,
        campaignid,
        agentid,
        datefrom: startdate,
        dateto: enddate
      });
      setEvolutionData(response);
    } catch (err) {
      console.error('Error al recuperar los datos del scorecard: ', err);
    }
  }, [scorecardid, startdate, enddate, serviceid, campaignid, agentid]);

  const fetchData2 = useCallback(async () => {
    try {
      const response = await fetchHVAScorecardDashScoreDistribution({
        scorecardid,
        serviceid,
        campaignid,
        agentid,
        datefrom: startdate,
        dateto: enddate
      });
      setDistributionData(response);
    } catch (err) {
      console.error('Error al recuperar los datos de distribución: ', err);
    }
  }, [scorecardid, startdate, enddate, serviceid, campaignid, agentid]);

  useEffect(() => {
    const fetchAllData = async () => {
      setLoading(true);
      await Promise.all([fetchData(), fetchData2()]);
      setLoading(false);
    };

    fetchAllData();
  }, [fetchData, fetchData2]);

  return (
    <>
      {loading ? (
        <Row className="justify-content-center align-items-center pt-3 w-100">
          <HVASpinner />
        </Row>
      ) : (
        <>
          <Row className="mb-1 mx-n3 px-0 pt-1 justify-content-start align-items-top">
            <Col sm={12} md={12} lg={6}>
              <h4>Score value distribution</h4>
              <p className="fs-9 mb-0">
                Normal distribution of score values achieved
              </p>
              {distributionData && (
                <ScoreDistributionChart data={distributionData} />
              )}
            </Col>
            <Col sm={12} md={12} lg={6}>
              <h4>Score value and call duration analysis</h4>
              <p className="fs-9 mb-0">
                Is it call duration impacting the score achieved?
              </p>
              {evolutionData && <ScoreVsDurationChart data={evolutionData} />}
            </Col>
          </Row>
          <Row className="mb-1 mx-0 p-0 pt-3 justify-content-start align-items-top">
            <div className="px-0 mx-0">
              <QAScorecardData4
                scorecardid={scorecardid}
                startdate={startdate}
                enddate={enddate}
                serviceid={serviceid}
                campaignid={campaignid}
                agentid={agentid}
              />
            </div>
          </Row>
        </>
      )}
    </>
  );
};

export default React.memo(QAScorecardData3);
